import declarationEGTB from '@/content/pdf/Declaration-Aqad_EGTB_EN.pdf';
import declarationEGIB from '@/content/pdf/Declaration_EGIB_EN.pdf';
import importantNoticeEGIB from '@/content/pdf/Important-Notice_EGIB_EN.pdf';
import importantNoticeEGTB from '@/content/pdf/Important-Notice_EGTB_EN.pdf';
import pdsHohhAgencyEGIB from '@/content/pdf/PMG_EGIB_HOHH_PDS_AGENCY_ENG.pdf';
import pdsHohhBancaEGIB from '@/content/pdf/PMG_EGIB_HOHH_PDS_BANCA_ENG.pdf';
import policyHohhAgencyEGIB from '@/content/pdf/PMG_EGIB_HOHH_PW_AGENCY_ENG.pdf';
import policyHohhBancaEGIB from '@/content/pdf/PMG_EGIB_HOHH_PW_BANCA_ENG.pdf';
import pdsMyRumahAgencyEGIB from '@/content/pdf/PMG_EGIB_MYRUMAH_PDS_AGENCY_ENG.pdf';
import policyMyRumahAgencyEGIB from '@/content/pdf/PMG_EGIB_MYRUMAH_PW_AGENCY_ENG.pdf';
import policyHohhAgencyEGTB from '@/content/pdf/PMG_EGTB_HOHH_CW_AGENCY_ENG.pdf';
import policyHohhBancaEGTB from '@/content/pdf/PMG_EGTB_HOHH_CW_BANCA_ENG.pdf';
import pdsHohhAgencyEGTB from '@/content/pdf/PMG_EGTB_HOHH_PDS_AGENCY_ENG.pdf';
import pdsHohhBancaEGTB from '@/content/pdf/PMG_EGTB_HOHH_PDS_BANCA_ENG.pdf';
import policyMyRumahAgencyEGTB from '@/content/pdf/PMG_EGTB_MYRUMAH_CW_AGENCY_ENG.pdf';
import pdsMyRumahAgencyEGTB from '@/content/pdf/PMG_EGTB_MYRUMAH_PDS_AGENCY_ENG.pdf';
import privacyNoticeEGIB from '@/content/pdf/Privacy-Notice_EGIB_EN.pdf';
import privacyNoticeEGTB from '@/content/pdf/Privacy-Notice_EGTB_EN.pdf';
import pdsHohhEGTB from '@/content/pdf/PMG_EGTB_HOHH_PDS_ENG_2605V0.2.pdf';

export default {
  declaration_insurance: declarationEGIB,
  declaration_takaful: declarationEGTB,
  importantNotice_insurance: importantNoticeEGIB,
  importantNotice_takaful: importantNoticeEGTB,
  privacyNotice_insurance: privacyNoticeEGIB,
  privacyNotice_takaful: privacyNoticeEGTB,
  pds: {
    hohh: {
      Direct_insurance: 'https://eti.qa/go/hohh-pds-en',
      Direct_takaful: pdsHohhEGTB,
      Indirect_insurance: pdsHohhAgencyEGIB,
      Indirect_takaful: pdsHohhAgencyEGTB,
      Agent_insurance: pdsHohhAgencyEGIB,
      Agent_takaful: pdsHohhAgencyEGTB,
      Banca_insurance: pdsHohhBancaEGIB,
      Banca_takaful: pdsHohhBancaEGTB,
    },
    myrumah: {
      Direct_insurance: 'https://eti.qa/go/myrumah-pds-en',
      Direct_takaful: 'https://eti.qa/go/myrumah-tak-pds-en',
      Indirect_insurance: pdsMyRumahAgencyEGIB,
      Indirect_takaful: pdsMyRumahAgencyEGTB,
      Agent_insurance: pdsMyRumahAgencyEGIB,
      Agent_takaful: pdsMyRumahAgencyEGTB,
      Banca_insurance: pdsMyRumahAgencyEGIB,
      Banca_takaful: pdsMyRumahAgencyEGTB,
    },
  },
  policyContract: {
    hohh: {
      Direct_insurance: 'https://eti.qa/go/hohh-policy',
      Direct_takaful: 'https://eti.qa/go/hohh-certificate',
      Indirect_insurance: policyHohhAgencyEGIB,
      Indirect_takaful: policyHohhAgencyEGTB,
      Agent_insurance: policyHohhAgencyEGIB,
      Agent_takaful: policyHohhAgencyEGTB,
      Banca_insurance: policyHohhBancaEGIB,
      Banca_takaful: policyHohhBancaEGTB,
    },
    myrumah: {
      Direct_insurance: 'https://eti.qa/go/myrumah-policy',
      Direct_takaful: 'https://eti.qa/go/myrumah-certificate',
      Indirect_insurance: policyMyRumahAgencyEGIB,
      Indirect_takaful: policyMyRumahAgencyEGTB,
      Agent_insurance: policyMyRumahAgencyEGIB,
      Agent_takaful: policyMyRumahAgencyEGTB,
      Banca_insurance: policyMyRumahAgencyEGIB,
      Banca_takaful: policyMyRumahAgencyEGTB,
    },
  },
};
